export default "__VITE_ASSET__k$HNeykR__"